import React, { useState, useContext, useEffect } from "react";


import clockIcon from "../../assets/images/clock.svg";

import { makeAPICall } from "../../services/apiService";

import { formatAmountinINR, getCookie, postCall } from "../../utils/utils";

import axios from "axios";
import "../posMachineId/posMachine.scss";
import { useHistory } from "react-router-dom";

const PaymentProcess = (props) => {
  const [loader, setLoader] = useState(false);
  const [counter, setCounter] = useState(0);

  const [minutes, setMinutes] = useState(5);
  const [seconds, setSeconds] = useState(0);
  const history = useHistory();
  const fromPurchaseFlow = getCookie("from_purchase_flow") || false

  useEffect(() => {
    let myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 30 || seconds === 59) {
        getPaymentStatusAPI();
      }
      if (seconds === 0) {
        if (minutes === 0) {
          reconcilePayuPayment();
          clearInterval(myInterval);
          if (fromPurchaseFlow) {
            const url = JSON.parse(localStorage.getItem('env_const'))?.purchase_url || ""
            if (url) {
              postCall(`${url}/cloakCustomer`, {
                redirectUrl: "/selectSavedCards"
              })
            }
          } else {
            history.push("/pos-unique-code");
          }
        } else {
          setMinutes(minutes - 1);
          setSeconds(59);
        }
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  });

  useEffect(() => {
    initiatePayuPayment();
  }, []);

  const reconcilePayuPayment = () => {
    let userOrdersDetails = localStorage.getItem("orderDetails");

    let orderDetails = JSON.parse(userOrdersDetails);

    let transactionId = getCookie("payu_transaction_id");

    var config = {
      method: "post",
      url: `api/pos/reconcilePayuPayment`,
      data: {
        transaction_id: transactionId,
        amount: orderDetails?.order_details?.amount,
        currency_code: "INR",
        utm_uuid: orderDetails?.order_details?.user_id,
        sub_tenant:"OLA_ELECTRIC",
        order_id: orderDetails?.order_details?.order_id,
        source_name:'PayU'
      },
    };

    makeAPICall(config)
      .then((resp) => {
        console.log("PayU RESPONSE", resp);
      })
      .catch((err) => {
        console.log("PayU Error RESPONSE", err);
        setLoader(false);
      });
  };

  const initiatePayuPayment = () => {
    let userOrdersDetails = localStorage.getItem("orderDetails");

    let orderDetails = JSON.parse(userOrdersDetails);

    let transactionId = getCookie("payu_transaction_id");
    let hashCode = getCookie("hash_code");

    var payuconfig = {
      method: "post",
      url: `api/pos/initiatePayuPayment`,
      data: {
        hashCode: hashCode,
        orderDetails: orderDetails,
        transactionId: transactionId,
      },
    };

    makeAPICall(payuconfig)
      .then((resp) => {
        console.log("PayU RESPONSE", resp);
      })
      .catch((err) => {
        console.log("PayU Error RESPONSE", err);
        setLoader(false);
      });
  };

  const getPaymentStatusAPI = () => {
    setLoader(true);

    let userOrdersDetails = localStorage.getItem("orderDetails");

    let orderDetails = JSON.parse(userOrdersDetails);

    let config = {
      method: "get",
      url: `api/pos/paymentStatus`,
      params: {
        unique_code: orderDetails?.order_details?.unique_code,
      },
    };

    makeAPICall(config)
      .then((resp) => {
        if (resp?.data?.status === "SUCCESSFUL") {
          if (resp.data.data.status === "TransactionFailure") {
            history.push("/transaction-status?status=failure");
          } else if (resp.data.data.status === "TransactionSuccess") {
            history.push("/transaction-status?status=success");
          } else {
          }
        }
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
      });
  };



  let userOrdersDetails = localStorage.getItem("orderDetails");

  let orderDetails = JSON.parse(userOrdersDetails);

  return (
    <div>
      <div className="pos-main-container">
        <div className="right-container">
          <div className="vertical-center-payment">
            <div className="pos-machine-container">
              <div className="form-container flex">
                <div className="form-controls">
                  <div className="payment">
                    <div className="label">
                      Please swipe customer’s card for a total amount of{" "}
                      {formatAmountinINR(orderDetails?.order_details?.amount)}
                    </div>
                  </div>
                  <div>
                    <div className="payment-process-desc">
                      Do not tap back button until the transaction is complete.
                      We will update you once the payment is complete.
                    </div>
                    <div
                      className="payment-process-desc"
                      style={{ marginTop: 26 }}
                    >
                      Time left to complete this transaction
                    </div>
                    {minutes === 0 && seconds === 0 ? null : (
                      <div className="timer-text">
                        <img src={clockIcon} style={{ marginRight: 8 }} />{" "}
                        {minutes < 10 ? `0${minutes}` : minutes}:
                        {seconds < 10 ? `0${seconds}` : seconds} min
                      </div>
                    )}
                  </div>

                  <div>
                    {/* <button
                      className={"submit_btn payment_cancel_btn"}
                      type="submit"
                      onClick={() => setShowValidationSheet(true)}
                    >
                      Cancel payment
                    </button> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentProcess;
